import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { loadGoogleFontsCSS } from "./assets/fonts";
import "./styles/global.css";

loadGoogleFontsCSS();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
